module.exports = __webpack_public_path__ + "static/media/Sleep_Image.05a12187.png";